/**
 *  点击加载
 */

define(function(require, exports, module) {

    const Base = require('c-base');

    const Refresh = Base.extend({
        defaults: {
            template: '<div class="ui-refresh" id="J-Refresh"><span></span></div>'
        },

        initialize: function() {
            this.Parent.apply(this, arguments);
        },

        render: function() {
            this.destory();
            this.buidDOM();
            this.bindEvent();
        },

        buidDOM() {
            this.el = $(this.get('template'));
            $(document.body).append(this.el);
        },

        bindEvent() {
            this.el.on('click', () => {
                this.anim();
                this.emit('refresh');
            });
        },

        anim() {
            let node = this.el;

            node.addClass('anim-spin');

            this.timer && clearTimeout(this.timer);

            this.timer = setTimeout(function() {
                node.removeClass('anim-spin');
            }, 400);
        },

        destory: function() {
            if (this.el) {
                this.el.off('click');
                this.el.remove();
            }
        }
    });

    UpAct.refresh = new Refresh;

});


// WEBPACK FOOTER //
// ./js/lib/refresh/index.js